export const shortDateFormat = 'MM/dd/yyyy';
